export const HACKATHONS_START = new Date('2026-10-06T10:00:00Z');
export const REGISTRATION_OPENS = new Date('2026-09-29T10:00:00Z');
export const REGISTRATION_CLOSES = new Date('2026-10-27T13:00:00Z');
export const SUBMISSIONS_OPEN = new Date('2026-10-05T10:00:00Z');
export const SUBMISSIONS_CLOSE = new Date('2026-10-27T13:00:00Z');
export const JUDGING_OPENS = new Date('2026-10-28T09:00:00Z');
export const JUDGING_CLOSES = new Date('2026-11-11T16:00:00Z');
export const WINNERS_ANNOUNCED = new Date('2026-11-16T13:00:00Z');

export type TranscendPhase
  = | 'upcoming'
    | 'registration'
    | 'submissions'
    | 'judging'
    | 'closed';

export function transcendPhase(now: Date = new Date()): TranscendPhase {
  if (now < REGISTRATION_OPENS) {
    return 'upcoming';
  }

  if (now < SUBMISSIONS_OPEN) {
    return 'registration';
  }

  if (now < SUBMISSIONS_CLOSE) {
    return 'submissions';
  }

  if (now < WINNERS_ANNOUNCED) {
    return 'judging';
  }

  return 'closed';
}

export function isShowcaseRegistrationOpen(now: Date = new Date()): boolean {
  return now >= REGISTRATION_OPENS && now < REGISTRATION_CLOSES;
}
